<div class="footer">
  <div class="content">
    <div class="left">
      <a
        [href]="homeUrl"
        merriNoFocusLink
        rel="noopener nofollow noreferrer"
        target="_blank"
      >
        <mat-icon [svgIcon]="brandingService.logoMarkIcon"></mat-icon>
      </a>

      <a
        [href]="PRIVACY_POLICY_URL"
        rel="noopener nofollow noreferrer"
        target="_blank"
        merriNoFocusLink
        >Privacy Policy</a
      >
      <a
        [href]="TOS_URL"
        rel="noopener nofollow noreferrer"
        target="_blank"
        merriNoFocusLink
        >Terms of Service</a
      >
    </div>
    <div class="right">
      <span class="copyright"> Copyright © {{ currentYear }} Tripleseat. All rights reserved. </span>
    </div>
  </div>
</div>
